import {connect} from 'react-redux';
import {GelPosition as Component} from './GelPosition';
import {
  showModal,
  incGelOrientation,
  decGelOrientation,
  setGelOrientation,
  ejectGelFromGelBox
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    orientation: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id-1].gelOrientation,
    containsGel: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id-1].containsGel,
    solution: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id-1].solutionAlias,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    incGelOrientation: (data) => {
      dispatch(incGelOrientation(data))
    },
    decGelOrientation: (data) => {
      dispatch(decGelOrientation(data))
    },
    setGelOrientation: (data) => {
      dispatch(setGelOrientation)(data)
    },
    ejectGelFromGelBox: (data) => {
      dispatch(ejectGelFromGelBox)(data)
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
 
  }
}

export const GelPosition = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
